import React from "react";
import { createContext, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { RootState } from "../store/store";
import { useLocation, useParams, useSearchParams } from "react-router-dom";
import { IInterview, IQuestion } from "../models/IQuestion";
import { callAPI } from "../services/interview.service";
import { useAuthToken } from "../hooks/useAuthToken";
import { Alert, Snackbar } from "@mui/material";

interface IShowMessage {
    message: string,
    label: string
}

export const MessageStore = createContext<{
    openMessage: boolean;
    setOpenMessage: (message: boolean) => void;
    showMessage: IShowMessage;
    setShowMessage: (message: IShowMessage) => void;
}>({
    openMessage: false,
    setOpenMessage: () => { },
    showMessage: {
        message: '',
        label: ''
    },
    setShowMessage: () => { },
});



MessageStore.displayName = "MessageContext";

function MessageContext({ children }: { children: React.ReactNode }) {
    const [openMessage, setOpenMessage] = useState<boolean>(true);
    const [showMessage, setShowMessage] = useState<IShowMessage>({
        label: '', 
        message:''
    });

    const handleCloseAlertDelete = () => {
        setOpenMessage(false)
    }


    return (
        <MessageStore.Provider
            value={{
                openMessage,
                setOpenMessage,
                showMessage,
                setShowMessage
            }}
        >
            {children}
          { showMessage.message && <Snackbar
                open={openMessage}
                autoHideDuration={3000}
                onClose={handleCloseAlertDelete}
                anchorOrigin={{ vertical: 'top', horizontal: 'right' }} 
            >
                <Alert
                    onClose={handleCloseAlertDelete}
                    severity='success'
                    // severity={showMessage.label}
                    variant="filled"
                    sx={{ width: "100%" }}
                >
                    {showMessage.message}
                </Alert>
            </Snackbar>}
        </MessageStore.Provider>
    );
}

export default MessageContext;
